export const isValidEmail = (email) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
};

export const isValidPhone = (phone) => {
  if (phone.length > 1) {
    const phonePattern = /^\(\d{3}\) \d{3} \d{2} \d{2}$/;
    return phonePattern.test(phone);
  } else {
    return true;
  }
};

export const isValidPassword = (password) => {
  const minLength = 8;
  const hasLowercase = /[a-z]/.test(password);
  const hasUppercase = /[A-Z]/.test(password);
  const hasDigit = /\d/.test(password);
  const hasSpecialChar = /[@$!%*?&.,]/.test(password);

  return (
    password.length >= minLength &&
    hasLowercase &&
    hasUppercase &&
    hasDigit &&
    hasSpecialChar
  );
};
export const phoneNumberFormatter = (phoneNumber) => {
  var phone = "";
  let rawNumber = phoneNumber.replace(/\D/g, "");

  if (rawNumber.length <= 3) {
    phone = rawNumber;
  } else if (rawNumber.length <= 6) {
    phone = `(${rawNumber.slice(0, 3)}) ${rawNumber.slice(3)}`;
  } else if (rawNumber.length <= 8) {
    phone = `(${rawNumber.slice(0, 3)}) ${rawNumber.slice(
      3,
      6
    )} ${rawNumber.slice(6)}`;
  } else {
    phone = `(${rawNumber.slice(0, 3)}) ${rawNumber.slice(
      3,
      6
    )} ${rawNumber.slice(6, 8)} ${rawNumber.slice(8, 10)}`;
  }
  return phone;
};

// tax id validation
export const isValidTaxId = (taxId, isCorporate) => {
  // if it is notcorporate it shpuld be exactly 11 digits
  // tax id is integer so we convert it to string to get the length
  taxId = taxId.toString();

  if (!isCorporate) {
    return taxId.length === 11;
  }
  // if it is corporate it should be exactly 10 digits
  return taxId.length === 10;
};
// Kart ismi validasyonu
export const isValidCardName = (cardName) => {
  // En az 5 karakter ve en az bir boşluk içermeli
  return cardName.length >= 5 && /\s/.test(cardName);
};

// Kart numarası formatlama
export const formatCardNumber = (cardNumber) => {
  return cardNumber
    .replace(/\D/g, "") // Sayı olmayan karakterleri kaldır
    .slice(0, 16) // İlk 16 karakteri al
    .replace(/(.{4})/g, "$1 ") // Her 4 rakamda bir boşluk ekle
    .trim(); // Başta ve sondaki boşlukları temizle
};

// Kart numarası validasyonu
export const isValidCardNumber = (cardNumber) => {
  const number = cardNumber.replace(/\s+/g, "");
  return number.length === 16;
};

// Son kullanma tarihi validasyonu
export const isValidExpiryDate = (expiryDate) => {
  return /^(0[1-9]|1[0-2])\/(\d{2})$/.test(expiryDate);
};

// Son kullanma tarihi formatlama
export const formatExpiryDate = (expiryDate) => {
  return expiryDate
    .replace(/\D/g, "") // Sayı olmayan karakterleri kaldır
    .slice(0, 4) // İlk 4 karakteri al
    .replace(/(.{2})/, "$1/") // İlk 2 karakterden sonra / ekle
    .trim(); // Başta ve sondaki boşlukları temizle
};

// CVC validasyonu
export const isValidCVC = (cvc) => {
  return /^[0-9]{3,4}$/.test(cvc);
};
